import React from "react";
import SelectField from "../../../shared/components/SelectField";

export default function FlowLevelSelect({ groupId, value, options = ["SL", "HL"], onChange }) {
  return (
    <div className="level-control">
      <SelectField
        label={`Subject ${groupId}: level`}
        value={value}
        onChange={onChange}
        options={["SL", "HL"].map(level => ({ value: level, label: level, disabled: !options.includes(level) }))}
      />
    </div>
  );
}
